export const POINTS_LEVEL = 1000
export const POINTS_SESSION_1 = 30
export const POINTS_SESSION_2 = 20
export const POINTS_SESSION_3 = 10
